<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
  <div class="row">
    <div class="col-12 col-md-4">
      <h1 class="title-default">Logs</h1>
    </div>
  </div>
  <form class="form" [formGroup]="model">
    <div class="row">
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>ID Log</mat-label>
          <input matInput type="text" formControlName="idLog" [readonly]="true" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>ID Empresa</mat-label>
          <input matInput type="text" formControlName="idEmpresa" [readonly]="true" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>ID Usuário</mat-label>
          <input matInput type="text" formControlName="idUsuario" [readonly]="true" />
        </mat-form-field>
      </div>
      <div class="col-md-3">
        <mat-form-field appearance="outline">
          <mat-label>Tipo</mat-label>
          <input matInput type="text" formControlName="tipo" [readonly]="true" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Projeto Origem</mat-label>
          <input matInput type="text" formControlName="projetoOrigem" [readonly]="true" />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field appearance="outline">
          <mat-label>Função Origem</mat-label>
          <input matInput type="text" formControlName="funcaoOrigem" [readonly]="true" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <mat-form-field appearance="outline">
          <mat-label>Data de Inclusão</mat-label>
          <input matInput type="text" formControlName="datetimeInclusao" [readonly]="true" />
        </mat-form-field>
      </div>
    </div>
  </form>
  <form
    class="form"
    [formGroup]="modelDadosSensiveis"
    *appTemPermissao="_PermissaoEnum.Desenvolvedor_Logs_VisualizarDadosSensiveis">
    <div class="title-header">
      <h1>Dados Sensíveis:</h1>
    </div>
    @if (dadosRevelados) {
      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Parâmetro de entrada</mat-label>
            <textarea matInput type="text" formControlName="parametroEntrada" [readonly]="true"></textarea>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Mensagem</mat-label>
            <textarea matInput type="text" formControlName="mensagem" [readonly]="true"></textarea>
          </mat-form-field>
        </div>
      </div>
    }
    @if (!dadosRevelados) {
      <div class="row">
        <div class="col-md-2">
          <button type="button" mat-button class="btn-primary" (click)="openModalRevelarDadosSensiveis()">
            Revelar
          </button>
        </div>
      </div>
    }
  </form>
  <div class="title-header">
    <h1>Lista de Acessos aos Dados Sensíveis:</h1>
  </div>
  @if (obterLogResponse?.logStruct?.listaLogAcesso) {
    <div class="card-list">
      <div class="row">
        @for (item of this.obterLogResponse.logStruct.listaLogAcesso; track item) {
          <div class="col-12 col-sm-6 col-md-4">
            <div class="card-item">
              <div class="infos">
                <span class="title">ID Usuário - {{ item.idUsuarioAdmin }}</span>
                <span class="title-2">{{ item.datetimeInclusao | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
